import React from 'react'

/**
 * Badge — rounded status capsule for account/state (active / invited).
 */
export function Badge({ tone = 'active', children, className = '' }) {
  const cls = ['badge', `badge-${tone}`, className].filter(Boolean).join(' ')
  return <span className={cls}>{children}</span>
}
